module.exports = __webpack_public_path__ + "static/media/ISS_emblem.fba7e73c.png";